import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { Icon } from "@iconify/react";
import { TrainingAcademyLatestNews } from "./LatestNews/LatestNews";
import { News } from "./News";
export const NewsTab = () => {
  const navigate = useNavigate();
  const query = useQuery();
  
  useEffect(() => {
    if(query.get('id')){
        return;
    }
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/training-academy?activeTab=news&subActiveTab=latestNews`, {
          replace: true,
        });
    }
  }, [query.get('activeTab'), query.get('subActiveTab')]);
  const items = [
    {
      label: "Latest News",
      key: "latestNews",
      children: (
        <TrainingAcademyLatestNews />
      ),
    },
    {
      label: "Latest News List",
      key: "latestNewsList",
      children: (
        <News />
      ),
    },
  ];

  const handleProductManagement=(activeTab:any, subActiveTab:any)=>{
    if(activeTab === 'news' && subActiveTab==='latestNewsList') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/corporate/training-academy/news/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
      >
        Add Latest News
      </Button>
      )
    }
  }

  return (
    // <ContentWrapper
    //   title={"Organization"}
    //   actionItems={
    //     handleProductManagement(query?.get('activeTab'), query?.get('subActiveTab'))
    //   }
    // >
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    // </ContentWrapper>
  );
};
